import LiveDetailPageContainer from './container'

export default LiveDetailPageContainer
